module.exports = __webpack_public_path__ + "img/intro-to-illustrator-2021.f4d97fd8.svg";